export enum VideoTypeSales {
  NoType = '',
  Marketing = 'Marketing',
  Prospecting = 'Prospecting',
  RespondToInquiry = 'Respond to Inquiry',
  ThanksForYourBusiness = 'Thanks For Your Business',
}
